export const dashboardConstant = {
  LOAD_CAMPAIGNS_START:"LOAD_CAMPAIGNS_START",
  LOAD_CAMPAIGNS: "LOAD_CAMPAIGNS",
  LOAD_CAMPAIGNS_ERROR:"LOAD_CAMPAIGNS_ERROR",
  UPDATE_CAMPAIGN_REQUEST:"UPDATE_CAMPAIGN_REQUEST",
  UPDATE_CAMPAIGN_DATE: "UPDATE_CAMPAIGN_DATE",
  UPDATE_CAMPAIGN_DATE_FAIL: "UPDATE_CAMPAIGN_DATE_FAIL",
};
